module.exports = __webpack_public_path__ + "static/media/icon-tel.243b1760.svg";